import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { User } from './user.model';


@Injectable()
export class AuthPolicyService {
    private _apiRoot: string;
    accessDeniedRoute: string;
    apiUnavailableRoute: string;

    constructor(private _http: HttpClient) {
        this._apiRoot = '/api/authpolicy';
        this.accessDeniedRoute = '/access-denied';
        this.apiUnavailableRoute = '/app-error';
    }

    // Gets the current user context
    getCurrentUser(): Observable<User> {

        console.log('AuthPolicyService -> getCurrentUser()');
        console.log(new Error().stack);

        const apiPath = `${this._apiRoot}/current-user`;
        return this._http.get<User>(apiPath);
    }
}